
import { Record } from 'immutable'
const Book = Record({
  offer_id:null,
  player_number:null
});
export default Book;
